import classNames from 'clsx';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { player } from 'src/client/player';
import SeekSlider from './SeekSlider';
import css from './scrubber.module.scss';

export class LiveSeekScrubber extends Component {
  static propTypes = {
    sliderMax: PropTypes.number.isRequired,
    elapsedTime: PropTypes.string.isRequired,
    elapsedPercent: PropTypes.number.isRequired,
    elapsedSeconds: PropTypes.number.isRequired,
    onChangeCommitted: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (event) event.preventDefault();

    player.seekTo(player.getDuration());
  }

  render() {
    const { isLive, sliderMax, elapsedTime, elapsedPercent, elapsedSeconds, onChangeCommitted } =
      this.props;

    return (
      <div data-testid="scrubberWrapper" className={css.scrubberWrapper}>
        <div className={css.elapsed} data-testid="elapsedWrapper">
          <span data-elapsedtime={elapsedSeconds} id="scrubberElapsed">
            {elapsedTime}
          </span>
        </div>
        <SeekSlider
          disabled={false}
          elapsedPercent={elapsedPercent}
          sliderMax={sliderMax}
          onChangeCommitted={onChangeCommitted}
          className={css.slider}
          data-testid="liveSeekSlider"
        />
        {isLive ? (
          <div
            id="scrubberDuration"
            className={classNames(css.liveSeekTextContainer, css.liveSeekText)}
          >
            LIVE
          </div>
        ) : (
          <div
            id="goLiveButton"
            data-testid="goLiveButton"
            className={classNames(css.liveSeekTextContainer, css.goLiveButton)}
            onClick={this.onClick}
          >
            GO LIVE
          </div>
        )}
      </div>
    );
  }
}

export default LiveSeekScrubber;
